import {
  Avatar,
  Card,
  CardActionArea,
  CardActions,
  CardContent,
  Collapse,
  createStyles,
  Divider,
  Grid,
  IconButton,
  makeStyles,
  Theme,
  Typography,
} from '@material-ui/core'
import CommentOutlinedIcon from '@material-ui/icons/CommentOutlined'
import React, { useEffect, useState } from 'react'
import clsx from 'clsx'

import { IDose } from 'daily-dose-common'
import { firestore } from '../../firebase-init'
import singleDoseIcon from '../../assets/images/single_dose_icon.png'

import * as Utilities from '../../utilities'
import firebase from 'firebase'
import { collectIdAndDocs } from '../../utilities'
import CommentList from '../../components/comment-list'
import { Like } from '../../components/like'
import { ExpandMore, SentimentVeryDissatisfiedIcon } from '../../assets/icons'

// TODO: move all these to one place
export interface ITodayDosePageProps<P> {
  match: IMatch<P>
  location: any
  history: any
  staticContext?: any
}

export interface IMatch<P> {
  params: P
  isExact: boolean
  path: string
  url: string
}

interface IMatchParams {
  id: string
}

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      minWidth: 275,
    },
    bullet: {
      display: 'inline-block',
      margin: '0 2px',
      transform: 'scale(0.8)',
    },

    small: {
      width: theme.spacing(4),
      height: theme.spacing(4),
      marginRight: theme.spacing(1),
    },
    expand: {
      transform: 'rotate(0deg)',
      marginLeft: 'auto',
      transition: theme.transitions.create('transform', {
        duration: theme.transitions.duration.shortest,
      }),
    },
    expandOpen: {
      transform: 'rotate(180deg)',
    },
    icon: {
      color: theme.palette.text.secondary,
      fontSize: 100,
    },
  })
)

// Max doses to query per page
const LIMIT = 2

const TodayDosePage = (route: ITodayDosePageProps<IMatchParams>) => {
  const classes = useStyles()
  // const { currentUser } = useContext(FirestoreContext)

  const [expanded, setExpanded] = React.useState(false)

  const handleExpandClick = () => {
    setExpanded(!expanded)
  }

  const circleId = route.match.params.id

  const circleRef = firestore.collection('circles').doc(circleId)
  const dosesRef = circleRef.collection('doses')
  const todaysDoseArray = dosesRef.where('status', '==', 'active')

  const [dose, setDose] = useState({} as IDose)
  const [loading, setLoading] = useState(true)
  const [
    todaysDoseRef,
    setTodaysDoseRef,
  ] = useState<firebase.firestore.DocumentReference<firebase.firestore.DocumentData> | null>(
    null
  )
  const [
    commentsRef,
    setCommentsRef,
  ] = useState<firebase.firestore.CollectionReference<firebase.firestore.DocumentData> | null>(
    null
  )

  const [
    commentsRefByDate,
    setCommentsRefByDate,
  ] = useState<firebase.firestore.Query<firebase.firestore.DocumentData> | null>(
    null
  )

  const [comments, setComments] = useState([] as any[])

  useEffect(() => {
    // TODO: Today's dose will come from a value from the circle document so this will not be necessary
    const unsubscribeFromTodaysDose = todaysDoseArray.onSnapshot(
      async (snapshot) => {
        const doses = snapshot.docs.map(Utilities.collectIdAndDocs)
        if (doses.length > 0) {
          const todaysDose = doses[0] as IDose
          const todaysDoseRef = firestore.doc(
            `circles/${todaysDose.circleId}/doses/${todaysDose.id}`
          )
          setTodaysDoseRef(todaysDoseRef)
          setDose(todaysDose)
          setLoading(false)
        } else {
          setDose({} as IDose)
          setLoading(false)
        }
      }
    )

    return () => {
      unsubscribeFromTodaysDose()
    }
    // eslint-disable-next-line
  }, [])

  useEffect(() => {
    if (!todaysDoseRef) return

    // Already fetched. Return
    if (commentsRef && commentsRefByDate) return

    const fetchComments = async () => {
      const commentsRef = todaysDoseRef.collection('comments')
      setCommentsRef(commentsRef)
      const commentsRefByDate = commentsRef.orderBy('createdAt', 'desc')
      setCommentsRefByDate(commentsRefByDate)
      const commentsQuery = commentsRefByDate.limit(LIMIT)
      const comments = (await commentsQuery.get()).docs.map(collectIdAndDocs)
      setComments(comments)
      setLoading(false)
    }

    fetchComments()
  }, [commentsRef, commentsRefByDate, todaysDoseRef])

  if (loading) {
    return <div>Loading...</div>
  }

  if (Utilities.isObjectEmpty(dose)) {
    return (
      <Card className={classes.root} variant="outlined">
        <CardContent>
          <Grid container spacing={1}>
            <Grid
              item
              container
              direction="row"
              justify="flex-start"
              alignItems="center"
            >
              <Avatar src={singleDoseIcon} className={classes.small} />
              <Typography variant="h5" color="textPrimary">
                Today&apos;s dose
              </Typography>
            </Grid>
            <Grid item xs={12}>
              <Divider />
            </Grid>
            <Grid
              item
              container
              direction="column"
              alignItems="center"
              justify="center"
            >
              <Typography variant="h5" color="textSecondary" align="center">
                This group ran out of doses. Add more doses and continue the fun
              </Typography>
              <SentimentVeryDissatisfiedIcon className={classes.icon} />
            </Grid>
          </Grid>
        </CardContent>
      </Card>
    )
  }

  if (!dose.id) return null

  return (
    <Card className={classes.root} variant="outlined">
      <CardActionArea onClick={handleExpandClick}>
        <CardContent>
          <Grid container spacing={1}>
            <Grid
              item
              container
              direction="row"
              justify="flex-start"
              alignItems="center"
            >
              <Avatar src={singleDoseIcon} className={classes.small} />
              <Typography variant="h5" color="textPrimary">
                {dose.name}
              </Typography>
            </Grid>
            <Grid item xs={12}>
              <Typography
                color="textSecondary"
                gutterBottom
              >{`Today's dose`}</Typography>
              <Divider />
            </Grid>
            <Grid item container direction="column">
              <Typography variant="h5" component="h2" color="textSecondary">
                {dose.description}
              </Typography>
            </Grid>
          </Grid>
        </CardContent>
      </CardActionArea>
      <CardActions disableSpacing>
        <Like docRef={todaysDoseRef!} likeCount={dose.likeCount} size="medium" />
        <IconButton
          aria-label="comment"
          onClick={handleExpandClick}
          style={{ padding: '6px' }}
        >
          <Typography
            variant="body2"
            color="textSecondary"
            style={{ marginRight: '4px' }}
          >
            {dose.comments > 0 && `${dose.comments}`}
          </Typography>
          <CommentOutlinedIcon fontSize="inherit" />
        </IconButton>
        <IconButton
          className={clsx(classes.expand, {
            [classes.expandOpen]: expanded,
          })}
          onClick={handleExpandClick}
          aria-expanded={expanded}
          aria-label="show more"
        >
          <ExpandMore fontSize="inherit" />
        </IconButton>
      </CardActions>
      <Collapse in={expanded} timeout="auto" unmountOnExit>
        <CardContent>
          <CommentList
            comments={comments}
            commentsRef={commentsRef}
            commentsRefByDate={commentsRefByDate}
            dose={dose}
          />
        </CardContent>
      </Collapse>
    </Card>
  )
}

export default TodayDosePage
